/* NHOI — cart drawer "buddy" add button.
   Adds one variant with /cart/add.js, asks for the same sections the theme's own cart
   actions request, then publishes the theme's cartUpdate event so the drawer
   re-renders in place (items, buddy module, totals, free-shipping state). */
(() => {
  if (window.__nhoiCartBuddy) return;
  window.__nhoiCartBuddy = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nhoi-buddy-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    const box = button.closest('[data-nhoi-buddy]');
    const errorEl = box && box.querySelector('.nhoi-buddy__error');
    if (errorEl) errorEl.hidden = true;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');

    try {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.nhoiBuddyAdd), quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add this item.');
      }

      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      cart.sections = data.sections;

      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart, source: 'nhoi-buddy' });
      } else {
        window.location.reload();
      }
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      if (errorEl) {
        errorEl.textContent = error.message;
        errorEl.hidden = false;
      }
    }
  });
})();